const ENTITY_MAP: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '/': '&#x2F;',
};

export function escapeHtml(str: string): string {
  return str.replace(/[&<>"'/]/g, (ch) => ENTITY_MAP[ch] ?? ch);
}

export function sanitizeNumeric(value: string | number, min: number, max: number, fallback: number): number {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) return fallback;
  return Math.max(min, Math.min(max, num));
}

export function sanitizeInt(value: string | number, min: number, max: number, fallback: number): number {
  const num = typeof value === 'string' ? parseInt(value, 10) : value;
  if (isNaN(num)) return fallback;
  return Math.max(min, Math.min(max, Math.round(num)));
}
